module.exports = __webpack_public_path__ + "i18n/en_277a0030430fe2b46dfc4f2a00c02d09.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/en.json
// module id = aY29
// module chunks = 153